export const UNSUBSCRIBE_EXAMPLES = {
    account: '(i.e. payment’s status, payment methods information)',
    marketing: '(i.e. special offers, new features release)',
    campaign: '(i.e. engagements, campaign status)'
};
